import { render, staticRenderFns } from "./ListTabs.vue?vue&type=template&id=4eebc179&"
import script from "./ListTabs.vue?vue&type=script&lang=js&"
export * from "./ListTabs.vue?vue&type=script&lang=js&"
import style0 from "./ListTabs.vue?vue&type=style&index=0&id=4eebc179&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports